import * as React from "react";

import DeprecatedButton from "@v1/components/designSystem/button/Button";
import SvgEmpyProjects from "@v1/svg/empty-projects";

export function EmptyProjectMembership({
  shouldShowCreateProjectButton = true,
}: {
  shouldShowCreateProjectButton?: boolean;
}) {
  return (
    <div className="text-default mx-auto mt-20 flex max-w-80 flex-col items-center gap-8">
      <SvgEmpyProjects />
      <h3 className="text-xl font-medium">
        {shouldShowCreateProjectButton
          ? "Create your first project to get started"
          : "No project yet — connect your Shopify theme to get started."}
      </h3>
      {shouldShowCreateProjectButton && (
        <DeprecatedButton size="base" variant="primary" to="../project/new">
          New Project
        </DeprecatedButton>
      )}
    </div>
  );
}
